import ButtonGroup from './ButtonGroup.vue'
import CheckboxTag from './CheckboxTag.vue'
import CustomButton from './CustomButton.vue'
import GroupingIcon from './GroupingIcon.vue'
import InlineActionBtn from './InlineActionBtn.vue'
import WordTag from './WordTag.vue'

export {
  ButtonGroup,
  CheckboxTag,
  CustomButton,
  GroupingIcon,
  InlineActionBtn,
  WordTag
}



// WEBPACK FOOTER //
// ./src/components/parts/utils/buttons/index.js